import React, { useEffect } from 'react';
import { Spin, Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const RedirectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: white;
  color: #333;
`;

const RedirectContent = styled.div`
  text-align: center;
  max-width: 400px;
  padding: 2rem;
`;

const ZidRedirect = () => {
  const { t } = useTranslation();
  const zidOAuthUrl = 'https://oauth.zid.sa/oauth/authorize?client_id=4519&redirect_uri=https://sellerhub.staging.loops.sa/callback-zid&response_type=code';

  useEffect(() => {
    // Add a small delay to show the loading state
    const timer = setTimeout(() => {
      window.location.href = zidOAuthUrl;
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <RedirectContainer>
      <RedirectContent>
        <Spin size="large" style={{ marginBottom: '1rem' }} />
        <Text style={{ color: '#333', fontSize: '1.2rem', display: 'block', marginBottom: '0.5rem' }}>
          {t('zidRedirect.redirecting', 'Redirecting to Zid...')}
        </Text>
        <Text style={{ color: '#666', fontSize: '0.9rem' }}>
          {t('zidRedirect.pleaseWait', 'Please wait while we redirect you to Zid for authentication.')}
        </Text>
      </RedirectContent>
    </RedirectContainer>
  );
};

export default ZidRedirect;
